import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1a786a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "strenght" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("label", null, _toDisplayString(_ctx.label), 1),
      _createElementVNode("input", {
        type: "password",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.password = $event.target.value)),
        _pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,12}$",
        autocomplete: "new-password",
        autocorrect: "off",
        autocapitalize: "off",
        spellcheck: "false"
      }, null, 32),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: _normalizeClass(["green", {hide:(_ctx.score!==4)}])
        }, "Strength: Strong!", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["yellow", {hide:(_ctx.score!==3)}])
        }, "Strength: Medium!", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["orange", {hide:(_ctx.score!==2)}])
        }, "Strength: Weak!", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["red", {hide:(_ctx.score!==1)}])
        }, "Your password must be at least 6 characters long.", 2)
      ])
    ])
  ]))
}